import { ChainId, NATIVE_CURRENCY } from './chains'
import { Token } from '../sdk-core/entities/token'
import { NativeCurrency } from '../sdk-core/entities/nativeCurrency'
import invariant from 'tiny-invariant'
import { WETH9_ADDRESS } from './addresses'

export const WBOME = {
  [ChainId.MAINNET]: new Token(ChainId.MAINNET, WETH9_ADDRESS[ChainId.MAINNET], 18, 'WBOME', 'Wrapped Bome'),
  [ChainId.TESTNET]: new Token(ChainId.TESTNET, WETH9_ADDRESS[ChainId.TESTNET], 18, 'WBOME', 'Wrapped Bome'),
  [ChainId.ZKCRO]: new Token(ChainId.ZKCRO, WETH9_ADDRESS[ChainId.ZKCRO], 18, 'WZKCRO', 'Wrapped ZKCRO'),
  [ChainId.SONEIUM]: new Token(ChainId.SONEIUM, WETH9_ADDRESS[ChainId.SONEIUM], 18, 'WETH', 'Wrapped Ether'),
  [ChainId.DBK]: new Token(ChainId.DBK, WETH9_ADDRESS[ChainId.DBK], 18, 'WETH', 'Wrapped Ether'),
  [ChainId.ABSTRACT]: new Token(ChainId.ABSTRACT, WETH9_ADDRESS[ChainId.ABSTRACT], 18, 'WETH', 'Wrapped Ether'),
  [ChainId.ABSTRACT_TESTNET]: new Token(ChainId.ABSTRACT_TESTNET, WETH9_ADDRESS[ChainId.ABSTRACT_TESTNET], 18, 'WETH', 'Wrapped Ether'),
  [ChainId.BERACHAIN]: new Token(ChainId.BERACHAIN, WETH9_ADDRESS[ChainId.BERACHAIN], 18, 'WBERA', 'Wrapped Bera'),
  [ChainId.HYPERLIQUID]: new Token(ChainId.HYPERLIQUID, WETH9_ADDRESS[ChainId.HYPERLIQUID], 18, 'WHYPE', 'Wrapped Hype'),
}
export const WETH9 = WBOME

export class Okb extends NativeCurrency {
  protected constructor(chainId: number) {
    const native = NATIVE_CURRENCY[chainId as ChainId]
    super(chainId, native.decimals, native.symbol, native.name)
  }

  public get wrapped(): Token {
    const weth9 = WBOME[this.chainId as ChainId]
    invariant(!!weth9, 'WRAPPED')
    return weth9
  }

  private static _etherCache: { [chainId: number]: Okb } = {}

  public static onChain(chainId: number): Okb {
    return this._etherCache[chainId] ?? (this._etherCache[chainId] = new Okb(chainId))
  }

  public equals(other: NativeCurrency | Token): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
